import ApiModule from "../base";

export default class PasswordsModule extends ApiModule {
  constructor(baseURL: string) {
    super(baseURL, "auth/passwords");
  }

  async create(email: string): Promise<boolean> {
    const request = new Request(this.url, {
      method: "POST",
      headers: this._defaultHeaders(),
      body: JSON.stringify({ email }),
    });
    return await this._resolve(request);
  }

  async update(token: string, password: string): Promise<boolean> {
    const request = new Request(`${this.url}/${token}`, {
      method: "POST",
      headers: this._defaultHeaders(),
      body: JSON.stringify({ password }),
    });
    return await this._resolve(request);
  }
}
